<template>
  <swiper
    :autoplay="autoplay"
    :breakpoints="breakpoints"
    :modules="modules"
    :navigation="false" 
    class="operator-list"
  >
    <swiper-slide
      v-for="(operator, index) in operators"
      :key="index"
    >
      <operator-icon :name="operator"/>
    </swiper-slide>
  </swiper>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import operatorIcon from './icons/operatorIconGray.vue';

import 'swiper/css';
import 'swiper/css/autoplay';


export default defineComponent({
  components: {
    operatorIcon,
    Swiper,
    SwiperSlide
    
  },
  setup() {
    const operators = ref(['kcell','tele2','altel','activ','beeline']);

    const breakpoints = ref({
      320: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      375: {
        slidesPerView: 1.7,
        spaceBetween: 5,
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 5,
        pagination: {
          clickable: false,
        }
      },
      768:{
        slidesPerView: 5,
        spaceBetween: 5,

      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    });

    const autoplay = ref({
      delay: 2000,
      disableOnInteraction: false
    });

    return {
      breakpoints,
      modules: [ Autoplay ],
      operators,
      autoplay
    };
  },
});
</script>
<style lang="scss" scoped>
.operator-list{
    padding: 36px 20px;
}
</style>